import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import {
  Container,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';

import './style.scss';

const NodeDetailPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeDetailPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;
  const heroImage = node.field_media_item[0]?.styles.original;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>

      <div className="NodeDetailPage__hero">
        <div className="NodeDetailPage__hero__image">
          <Image
            src={heroImage}
            alt={heroTitle}
            lazyload={false}
          />
        </div>
        <Container>
          <div className="NodeDetailPage__hero__text">
            <h1 itemProp="name">{heroTitle}</h1>
            {heroBody ? (
              <WysiwygField
                property="schema:text"
                html={heroBody}
              />
            ) : null}
          </div>
        </Container>
      </div>

      <Container>
        {entity.get('field_paragraphs') ? (
          <div className="NodeDetailPage__paragraphs">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}
      </Container>

    </article>
  );
};

export default NodeDetailPage;
